import type { AccountCompletionItem } from "./accountCompletion";

type RecentAccountCompletion = {
	account: AccountCompletionItem;
	timestamp: string;
};

const storageKey = "RecentAccountCompletions";
const expiryMs = 7 * 24 * 60 * 60 * 1000;

function readEntries(): RecentAccountCompletion[] {
	try {
		const raw = localStorage.getItem(storageKey);
		if (!raw) return [];
		return JSON.parse(raw) as RecentAccountCompletion[];
	} catch {
		return [];
	}
}

function writeEntries(entries: RecentAccountCompletion[]): void {
	localStorage.setItem(storageKey, JSON.stringify(entries));
}

function pruneExpired(entries: RecentAccountCompletion[]): RecentAccountCompletion[] {
	const cutoff = Date.now() - expiryMs;
	return entries.filter((e) => Date.parse(e.timestamp) > cutoff);
}

function isSameAccount(a: AccountCompletionItem, b: AccountCompletionItem): boolean {
	return a.type === b.type && a.id === b.id;
}

export function saveRecentCompletion(account: AccountCompletionItem): void {
	const entries = pruneExpired(readEntries());
	const deduped = entries.filter((e) => !isSameAccount(e.account, account));
	const updated = [{ account, timestamp: new Date().toISOString() }, ...deduped];
	writeEntries(updated);
}

export function isRecentCompletion(account: AccountCompletionItem): boolean {
	const entries = pruneExpired(readEntries());
	return entries.some((e) => e.account.type === account.type && e.account.id === account.id);
}

export function getRecentCompletions(type?: "influencer" | "social_account"): AccountCompletionItem[] {
	const entries = pruneExpired(readEntries());
	writeEntries(entries);
	const filtered = type ? entries.filter((e) => e.account.type === type) : entries;
	return filtered.map((e) => e.account);
}
